// extracted by mini-css-extract-plugin
module.exports = {"wrapRunnerPageRemake":"runner_wrapRunnerPageRemake__4XBaU"};